/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum EnteralNutritionViewerAliases {
  CONTEXTUAL_BAR_ACTION_ADJUST_SPEED = 'contextual-bar-action-adjust-speed',
  CONTEXTUAL_BAR_ACTION_RESCHEDULE = 'contextual-bar-action-reschedule',
  CONTEXTUAL_BAR_ACTION_REVERSE = 'contextual-bar-action-reverse',
  CONTEXTUAL_BAR_ACTION_SUSPEND = 'contextual-bar-action-suspend',
  CONTEXTUAL_BAR_ACTION_TERMINATE = 'contextual-bar-action-terminate',
  ENTERAL_NUTRITION_CONTENT_PANEL = 'enteral-nutrition-content-panel',
  ENTERAL_NUTRITION_DETAILS_CARD = 'enteral-nutrition-details-card',
  ENTERAL_NUTRITION_FOOTER_PANEL = 'enteral-nutrition-footer-panel',
  ENTERAL_NUTRITION_VIEWER_CONTEXTUAL_BAR = 'enteral-nutrition-viewer-contextual-bar',
  ENTERAL_NUTRITION_VIEWER_DECK = 'enteral-nutrition-viewer-deck',
  ENTERAL_NUTRITION_VIEWER_LAYOUT = 'enteral-nutrition-viewer-layout',
  EXECUTE_TIME_BUTTON = 'execute-time-button',
  EXECUTE_TIME_PANEL = 'execute-time-panel',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INTERRUPT_BUTTON = 'interrupt-button',
  PANEL_HEADER = 'panel-header',
}
export { EnteralNutritionViewerAliases };
